import { Box, Divider, Typography } from "@mui/material";
import { TraderAvatar } from "src/components/common/trader-avatar";
import { HoverCard, IHoverCardProps } from "src/components-mui/common/hover-card/hover-card";
import { Ranking } from "src/components-mui/common/ranking/ranking";
import { IHeroSliderWikifolioData } from "src/components-mui/modules/hero-module/hero-slider-module.types";
import { useGetUserName } from "src/hooks/use-get-user-name";
import { useLinkBuilder } from "src/hooks/use-link-builder";

interface IHeroSliderWikifolioCardProps extends IHeroSliderWikifolioData {
    sx?: IHoverCardProps["sx"];
}

export const HeroSliderWikifolioCard = ({ trader, symbol, shortDescription, firstRanking, secondRanking, sx }: IHeroSliderWikifolioCardProps) => {
    const { buildWikifolioLink } = useLinkBuilder();
    const getUserName = useGetUserName();

    return (
        <HoverCard component="a" href={buildWikifolioLink(symbol)} display="flex" flexDirection="column" width={["292px", "292px", "318px"]} sx={sx}>
            <Box display="flex" alignContent="center" alignItems="center" marginBottom={1}>
                <TraderAvatar size={["lg", "lg", "xl"]} trader={trader} mr={1} />
                <Box overflow="hidden">
                    <Typography
                        fontSize={["md", "md", "lg"]}
                        fontWeight="bold"
                        sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                        {getUserName(trader)}
                    </Typography>
                    <Typography fontSize={["xs", "xs", "sm"]} sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", mt: 0.5 }}>
                        {shortDescription}
                    </Typography>
                </Box>
            </Box>
            <Box display="flex" gap={1} justifyContent="center">
                <Ranking size="md" data={firstRanking} alignItems="center" alignContent="center" sx={{ width: "50%" }} />
                <Divider orientation="vertical" sx={{ height: "49px" }} />
                <Ranking size="md" data={secondRanking} alignItems="center" alignContent="center" sx={{ width: "50%" }} />
            </Box>
        </HoverCard>
    );
};
